import { userApi as api, userSilentApi as silentApi } from "../../utils/apiInstances";

// Function to get user cards
export const handleGetUserCards = async <TData = unknown>() => {
    try {
        const response = await silentApi<TData>("GET", "/user/cards");
        return response;
    } catch {
        return undefined;
    }
};

export const handleSetPaymentMethod = async (userData: unknown, onSuccess: (res: unknown) => void, onError?: (err: unknown) => void) => {
    try {
        const response = await api("POST", "/user/cards", userData);
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};

// Function to handle card delete
export const handleDeleteCardById = async (cardID: string | number, onSuccess: (res: unknown) => void, onError?: (err: unknown) => void) => {
    try {
        const response = await api("DELETE", `/user/cards/${cardID}`);
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};
